import { useTranslation } from 'react-i18next'

import { roundHours } from '../../utils/format'

interface MyTeamTooltipProps {
  billableHours: number
  nonBillableHours: number
  missingHours?: number
  utilization: number
  showUtilization?: boolean
}

export const MyTeamTooltip = ({
  billableHours,
  nonBillableHours,
  missingHours,
  utilization,
  showUtilization = false,
}: MyTeamTooltipProps) => {
  const { t } = useTranslation()

  return (
    <div className="my-team-tooltip">
      {showUtilization && (
        <div className="my-team-tooltip__header">
          <span className="my-team-tooltip__label">
            {t('timeTracking.billing.utilization')}
          </span>
          <span className="my-team-tooltip__value">{utilization}%</span>
        </div>
      )}
      <div className="my-team-tooltip__rows">
        <div className="my-team-tooltip__row">
          <span className="my-team-tooltip__badge my-team-tooltip__badge--billable">
            {t('timeTracking.billing.billable')}
          </span>
          <span className="my-team-tooltip__hours">
            {roundHours(billableHours)}h
          </span>
        </div>
        <div className="my-team-tooltip__row">
          <span className="my-team-tooltip__badge my-team-tooltip__badge--non-billable">
            {t('timeTracking.billing.nonBillable')}
          </span>
          <span className="my-team-tooltip__hours">
            {roundHours(nonBillableHours)}h
          </span>
        </div>
        {missingHours !== undefined && missingHours > 0 && (
          <div className="my-team-tooltip__row">
            <span className="my-team-tooltip__badge my-team-tooltip__badge--missing">
              {t('timeTracking.billing.notTracked')}
            </span>
            <span className="my-team-tooltip__hours">
              {roundHours(missingHours)}h
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
